import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBYuKldERFAIAa4DKEInte0FD8t6my4Uww',
  authDomain: 'api-14p9.firebaseapp.com',
  databaseURL: 'https://api-14p9.firebaseio.com',
  projectId: 'api-14p9',
  storageBucket: 'api-14p9.appspot.com',
  messagingSenderId: '647986159112'
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const database = firebase.database();

export { firestore, auth, storage, database };
export default firebase;
